import { Link } from "react-router-dom";
import type { Match } from "@/mocks/matches";
import TeamBadge from "@/components/base/TeamBadge";
import StatusBadge from "@/components/base/StatusBadge";

interface MatchCardProps {
  match: Match;
}

export default function MatchCard({ match }: MatchCardProps) {
  const hasScore = match.status !== "upcoming" && match.score;
  return (
    <Link
      to={`/detail/${match.id}`}
      className="block bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/40 transition-colors cursor-pointer"
    >
      <div className="flex items-center justify-between gap-2 mb-4">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-xs font-medium text-primary-700 bg-primary-100 px-2 py-0.5 rounded-md whitespace-nowrap">
            {match.leagueName}
          </span>
          <span className="text-xs text-foreground-400 truncate">{match.round}</span>
        </div>
        <StatusBadge status={match.status} minute={match.minute} />
      </div>

      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <TeamBadge short={match.home.short} color={match.home.color} size="sm" />
          <span className="text-sm font-medium text-foreground-900 truncate">
            {match.home.name}
          </span>
        </div>

        <div className="shrink-0 text-center px-2">
          {hasScore ? (
            <span className="font-label text-2xl font-semibold text-foreground-950 tracking-wider">
              {match.score?.home} <span className="text-foreground-300">:</span>{" "}
              {match.score?.away}
            </span>
          ) : (
            <span className="font-label text-base font-medium text-foreground-700">
              {match.time}
            </span>
          )}
        </div>

        <div className="flex items-center gap-2.5 min-w-0 flex-1 justify-end">
          <span className="text-sm font-medium text-foreground-900 truncate text-right">
            {match.away.name}
          </span>
          <TeamBadge short={match.away.short} color={match.away.color} size="sm" />
        </div>
      </div>

      <div className="flex items-center justify-between gap-2 mt-4 pt-3 border-t border-background-100">
        <span className="text-xs text-foreground-400 truncate">
          {match.date} · {match.venue}
        </span>
        <span className="text-xs text-foreground-400 whitespace-nowrap">
          {hasScore ? "查看赛况" : "赛前预览"}
        </span>
      </div>
    </Link>
  );
}